const data = {
  data: [
    {
      id: 1,
      cif: 'A12345678',
      company_id: 7,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 1',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: false,
      automatic_download: true,
      send_alerts: true,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 2,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 2',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: true,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2,
      locations: [
        {
          id: 1,
          cif: 'A12345678',
          location: 'Sede 1',
          activated: true,
          access: '',
          certificate: 'Certificado 1',
          connection: true,
          user: 'usuario 1'
        },
        {
          id: 2,
          cif: 'A12345678',
          location: 'Sede 2',
          activated: true,
          access: '',
          certificate: 'Certificado 2',
          connection: false,
          user: 'usuario 2'
        }
      ]
    },
    {
      id: 3,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 3',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: false,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 4,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 4',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: false,
      automatic_download: true,
      send_alerts: true,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 5,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 5',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: false,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 6,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 6',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: false,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 7,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 7',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: false,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 8,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 8',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: false,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 9,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 9',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: false,
      automatic_download: true,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 10,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 10',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: true,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 11,
      cif: 'A12345679',
      company_id: 11,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 2',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: true,
      automatic_download: true,
      send_alerts: true,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    },
    {
      id: 12,
      cif: 'A12345679',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Empresa 12',
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      phone: '926.346.2740',
      email_alerts: 'marietta.osinski@stark.net',
      email_downloads: 'marietta.osinski@stark.net',
      email_days_alert: 'marietta.osinski@stark.net',
      certificate: false,
      automatic_download: true,
      send_alerts: false,
      automatic_download_days: 10,
      download_alert_days: 2,
      end_alert_days: 2
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
